export const getServices = (type, value) => {
  return {
    type: type,
    payload: value,
  }
}
